$(document).ready(function(){

  $('.i-1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        fade: false,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 4500,
        arrows: true,
        infinite: true,
        cssEase: 'ease-in-out',
        touchThreshold: 100,
        prevArrow:"<img class='a-left control-c prev slick-prev prv' src='https://cdn.shopify.com/s/files/1/0550/6125/0275/files/arw-lt.png?v=1750761184'>",
        nextArrow:"<img class='a-right control-c next slick-next nxt' src='https://cdn.shopify.com/s/files/1/0550/6125/0275/files/arw-rt.png?v=1750761184'>",
        pauseOnHover: false,
        pauseOnFocus: false
})
});


//Video Play On Click
$(document).ready(function() {
  $('.vdo-block .video').parent().click(function () {
         if($(this).children(".video").get(0).paused){ $(this).children(".video").get(0).play();   $(this).children(".playpause, .cap").fadeOut();
         }else{       $(this).children(".video").get(0).pause();
         $(this).children(".playpause, .cap").fadeIn();
         }
         });
  });

//Jarallax
$(document).ready(function(){
jarallax(document.querySelectorAll('.jarallax'));
jarallax(document.querySelectorAll(".jarallax-keep-img"), {
           keepImg: true,
         });
});

//Tab switching function
function openLocation(evt, locationName) {
    var i, tabcontent, tablinks;
    
    // Hide all tab contents and remove active class
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].classList.remove("active");
    }
    
    // Remove active class from all tab links
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }
    
    // Show target tab content and add active class
    var targetContent = document.getElementById(locationName);
    if (targetContent) {
        targetContent.style.display = "block";
        targetContent.classList.add("active");
    }
    
    // Add active class to clicked tab link
    evt.currentTarget.classList.add("active");
    
    // Prevent default link behavior
    evt.preventDefault();
}
// Removed defaultOpen click - now handled by GSAP implementation


document.addEventListener('DOMContentLoaded', function() {
            const panels = document.querySelectorAll('.accordion-panel');
            if (!panels.length) return;

            panels.forEach(panel => {
                panel.addEventListener('click', () => {
                    panels.forEach(p => p.classList.remove('active'));
                    panel.classList.add('active');
                });
                
                // Pre-load background images for smoother transitions
                const bgUrl = panel.querySelector('.background').style.backgroundImage.slice(4, -1).replace(/"/g, "");
                const img = new Image();
                img.src = bgUrl;
            });
            
            // Add touch events for mobile devices
            panels.forEach(panel => {
                panel.addEventListener('touchstart', function(e) {
                    // Prevent default only if this panel isn't already active
                    if (!panel.classList.contains('active')) {
                        e.preventDefault();
                    }
                }, { passive: false });
                
                panel.addEventListener('touchend', function() {
                    panels.forEach(p => p.classList.remove('active'));
                    panel.classList.add('active');
                });
            });
            
            // Initialize with a random panel active (except the first time)
            if (sessionStorage.getItem('visited') !== 'true') {
                sessionStorage.setItem('visited', 'true');
            } else {
                const randomIndex = Math.floor(Math.random() * panels.length);
                panels.forEach(p => p.classList.remove('active'));
                panels[randomIndex].classList.add('active');
            }
            
            // Add subtle mouse parallax effect to backgrounds
            document.addEventListener('mousemove', function(e) {
                const activePanel = document.querySelector('.accordion-panel.active');
                if (activePanel) {
                    const background = activePanel.querySelector('.background');
                    const mouseX = e.clientX / window.innerWidth;
                    const mouseY = e.clientY / window.innerHeight;
                    
                    // Subtle movement based on mouse position
                    background.style.transform = `scale(1.05) translate(${mouseX * -10}px, ${mouseY * -10}px)`;
                }
            });
            
            // Make the accordion container adapt to viewport changes
            function handleResize() {
                const container = document.querySelector('.container');
                const accordionContainer = document.querySelector('.accordion-container');
                
                if (window.innerWidth <= 992) {
                    // Mobile layout (vertical accordion)
                    container.style.height = '100%';
                    accordionContainer.style.height = '100%';
                } else {
                    // Desktop layout
                    container.style.height = '100%';
                    accordionContainer.style.height = '100%';
                }
            }
            
            window.addEventListener('resize', handleResize);
            handleResize(); // Initialize on load
        });


   